module.exports = __webpack_public_path__ + "static/img/office_04.c47f37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/office_04.png
// module id = lvcM
// module chunks = 0